import React from "react";
import { useQuery } from "@tanstack/react-query";
import { axiosget } from "../../helpers/httprequest";
import PageTitle from "../../components/PageTitle";
import Loader from "../../components/Loader";
import ErrorResponse from "../../components/ErrorResponse";
import "./VerticalTimeline.css";
import { FaCheckCircle, FaStar, FaTimesCircle, FaPrint } from "react-icons/fa";

const Registered = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["Registered"],
    queryFn: async () => {
      const response = await axiosget("ms_progression_profile/courseform");
      return response?.data;
    },
  });

  const sortedData = data?.sort((a, b) => a.step - b.step);

  const handlePrint = (id) => {
    window.open(`/print-registration/${id}`, "_blank");
  };

  if (isLoading) return <Loader />;
  if (error) return <ErrorResponse type="danger" message={error.message} />;

  return (
    <>
      <PageTitle title="Registered Modules" sub="Your complete registration history in a Academic Progression Timeline" />

      <div className="timeline-container">
        <div className="vertical-timeline">
          {sortedData?.map((item, index) => (
            <div key={item._id} className={`timeline-item ${item.isCurrent ? "current" : ""} ${item.isAdmitted ? "admitted" : "not-admitted"}`}>
              <div className="timeline-marker">
                <div className="marker-dot"></div>
                {index < sortedData.length - 1 && <div className="timeline-line"></div>}
              </div>

              <div className="timeline-content">
                <div className="timeline-header">
                  <div>
                    <h3 className="level-title">
                      {item.level}
                      {item.isCurrent && (
                        <span className="current-badge">
                          <FaStar /> Current
                        </span>
                      )}
                    </h3>
                    <span className="semester-tag">{item.semester}</span>
                  </div>
                </div>

                <div className="timeline-body">
                  <div className="status-pill">
                    {item.isAdmitted ? <FaCheckCircle /> : <FaTimesCircle />}
                    {item.isAdmitted ? "Admission Completed" : "Admission Not Granted"}
                  </div>

                  {item.isAdmitted && (
                    <button className="print-button" onClick={() => handlePrint(item._id)}>
                      <FaPrint className="button-icon" />
                      Print Registration
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Registered;
